export interface ReportSection {
  id: string
  theme: string
  subject?: string
  audience?: string
  scope?: string
}

export interface ReportData {
  title: string
  summary: string
  startDate: string
  endDate: string
  sections: ReportSection[]
}

const SCOPE_LABELS: Record<string, string> = {
  'top-5': 'Top 5 Performers',
  'this-week': 'Highest Performers This Week',
  distribution: 'Talent Trend Distribution',
  'over-time': 'Talent Trends Over Time',
}

/** Derives display heading from section configuration. */
export function getSectionHeading(section: ReportSection): string {
  const { theme, subject, scope } = section

  switch (theme) {
    case 'performance':
      return SCOPE_LABELS[scope || 'top-5'] ?? 'Top 5 Performers'

    case 'trends':
      return SCOPE_LABELS[scope || 'distribution'] ?? 'Talent Trend Distribution'

    case 'social':
      return 'Trending on Social'

    case 'industry-views': {
      const subjectLabel = subject === 'works' ? 'Works' : 'Talents'
      return `Most Viewed ${subjectLabel}`
    }

    default:
      return theme
        ? theme
            .split('-')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' ')
        : 'Untitled Section'
  }
}
